export default __webpack_public_path__ + "static/media/1615.82348393.png";